import { Link } from "react-router-dom";
import { Stack, Typography, Button } from "@mui/material";

import Modal from "Components/Modal";

interface IProps {
  isOpen: boolean;
  onClose: () => void;
  status: ISupport | null;
}
interface ISupport {
  crossings: { name: string; link: string }[];
  sanction_status: boolean;
  support: boolean;
}

export default function CheckService({ isOpen, onClose, status }: IProps) {
  return (
    <Modal open={isOpen} onClose={onClose} size="sm">
      <Stack alignItems="center" spacing={3} py={2}>
        <Typography color="text.secondary" variant="h5" fontWeight={600}>
          این سرویس <span style={{ color: status?.sanction_status ? "#d30000" : "green" }}>تحریم</span>{" "}
          {status?.sanction_status ? "است" : "نیست"}
        </Typography>

        {status?.crossings && (
          <Typography color="text.secondary" align="center" variant="h5">
            توسط سرویس 403 با استفاده از{" "}
            {status.crossings.map((i, index) => (
              <>
                <Link to={i.link} style={{ fontWeight: 600, color: "#275AF1" }}>
                  {i.name}
                </Link>
                {status.crossings[index + 1] && <span style={{ margin: "0 5px" }}>یا</span>}
              </>
            ))}{" "}
            پشتیبانی میشود
          </Typography>
        )}
        {status?.sanction_status && status?.support === false && (
          <>
            <Typography color="text.secondary" align="center" variant="h5">
              توسط سرویس 403 پشتیبانی نمیشود
            </Typography>

            <Link to="/request">
              <Button variant="contained" size="large" sx={{ fontWeight: 600 }}>
                درخواست ثبت سرویس
              </Button>
            </Link>
          </>
        )}
      </Stack>
    </Modal>
  );
}
